import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listGlobalConfig, reloadGlobalConfig } from './api';

export const useGlobalConfig = () => useQuery({ queryKey: ['admin-global-config'], queryFn: listGlobalConfig });


export const useReloadGlobalConfig = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: reloadGlobalConfig,
    onSuccess: () => client.invalidateQueries(),
  });
};
